import { useState } from 'react';
import Sidebar from './components/Sidebar';
import TopBar from './components/TopBar';
import Dashboard from './components/Dashboard';
import ProductionInventory from './components/ProductionInventory';
import ShipAssist from './components/ShipAssist';
import WaterGauge from './components/WaterGauge';
import ChannelInspection from './components/ChannelInspection';
import SecurityPatrol from './components/SecurityPatrol';
import EmergencyResponse from './components/EmergencyResponse';
import NightSurveillance from './components/NightSurveillance';
import ThreeDModeling from './components/ThreeDModeling';
import FacilityInspection from './components/FacilityInspection';
import PipelineInspection from './components/PipelineInspection';
import OilSpillMonitoring from './components/OilSpillMonitoring';
import DustMonitoring from './components/DustMonitoring';
import RealtimeDynamics from './components/RealtimeDynamics';
import DataReport from './components/DataReport';

export default function AdminPage() {
  const [selectedModule, setSelectedModule] = useState('实时动态');
  const [selectedSubModule, setSelectedSubModule] = useState('');

  const renderContent = () => {
    if (selectedModule === '实时动态') return <RealtimeDynamics />;
    if (selectedModule === '数据报表') return <DataReport />;

    if (selectedModule === '生产运营') {
      switch (selectedSubModule) {
        case '智能盘垛与库存管理': return <ProductionInventory />;
        case '船舶进出港辅助': return <ShipAssist />;
        case '水尺计重系统': return <WaterGauge />;
        case '航道与航标巡检': return <ChannelInspection />;
        default: return <ProductionInventory />;
      }
    }

    if (selectedModule === '安全应急') {
      switch (selectedSubModule) {
        case '全天候安防巡逻': return <SecurityPatrol />;
        case '突发环境事件应急': return <EmergencyResponse />;
        case '夜间与恶劣天气侦察': return <NightSurveillance />;
        case '三维建模与应急推演': return <ThreeDModeling />;
        default: return <SecurityPatrol />;
      }
    }

    if (selectedModule === '设施设备') {
      switch (selectedSubModule) {
        case '大型设施巡检': return <FacilityInspection />;
        case '输油管道巡检': return <PipelineInspection />;
        case '高架桥巡检': return <PipelineInspection />;
        default: return <FacilityInspection />;
      }
    }

    if (selectedModule === '环境保护') {
      switch (selectedSubModule) {
        case '海域油污监测': return <OilSpillMonitoring />;
        case '粉尘排放监控': return <DustMonitoring />;
        default: return <OilSpillMonitoring />;
      }
    }

    return <Dashboard />;
  };

  return (
    <div className="min-h-screen bg-slate-950 flex">
      <Sidebar
        selectedModule={selectedModule}
        selectedSubModule={selectedSubModule}
        onModuleSelect={setSelectedModule}
        onSubModuleSelect={setSelectedSubModule}
      />
      <div className="flex-1 flex flex-col">
        <TopBar onLogout={() => {}} />
        <main className="flex-1 p-8 overflow-y-auto">
          {renderContent()}
        </main>
      </div>
    </div>
  );
}
